<div class="panel-dev-container">
    <div class="actions-container">
        <div class="atril-actions">
            <h3>ATRIL</h3>
            <button (click)="startNewExperience()">Nueva Experiencia</button>
            <button [disabled]="!routeToken()" (click)="restartExperience()">Reiniciar Experiencia</button>
            <button [disabled]="!routeToken()" (click)="getChatbotWelcome()">Obtener Bienvenida</button>
        </div>
        <div class="immersive-actions">
            <h3>INMERSIVA</h3>
            <button (click)="restartImmersiveApp()">Reiniciar Pantalla Inmersiva</button>
            <button [disabled]="!routeToken()" (click)="startImmersiveAppByActualToken()">Iniciar Inmersiva Token Actual</button>
        </div>
    </div>
    <h3>LISTADO RUTAS</h3>
    <div class="route-list-container">
        @for (item of routeData(); track item.id) {
            <div class="grid-list">
                <span class="grid-list__id">{{ item.id }}</span>
                <span class="grid-list__name">{{ item.visitor_name }}</span>
                <span class="grid-list__email">{{ item.visitor_email }}</span>
                <span class="grid-list__date">{{ getDate(item.created_at) }}</span>
                <span class="grid-list__button" (click)="startRoute(item.token)">EMPEZAR RUTA</span>
            </div>
        }
    </div>
</div>